import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Entypo from "@mui/icons-material/ArrowBack";
import { getInvitedUsersList, sendInvite } from "../../../services/acc.services";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay.js";
import TeamsListModal from "../accSettings/teamsModal";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./AccSharing.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const initialState = {
    guestEmail: "",
    guestName: "",
    role: "",
    teams: []
};

const AccountSharing = (props) => {
    const [expandedRows, setExpandedRows] = useState([]);
    const [invitations, setInvitations] = useState(null);
    const [initialStateForm, setInitialStateForm] = useState(initialState);
    const [displayPhone, setDisplayPhone] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userDetailsLoader, setUserDetailsLoader] = useState(false);
    const [error, setError] = useState(null);
    const [successVisible, setSuccessVisible] = useState(false);
    const [delIsVisible, setDelIsVisible] = useState(false);
    const [delSuccessVisible, setDelSuccessVisible] = useState(false);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [selectTeamsVisible, setSelectTeamsVisible] = useState(false);
    const [selectedTeams, setSelectedTeams] = useState([]);

    const user = useSelector((state) => state.auth.user);

    const fetchInvitedUsers = async () => {
        try {
            const response = await getInvitedUsersList(user.token, user.email);
            setInvitations(response.data);
        } catch (e) {
            console.log("Failed at fetchInvitedUsers:: ", e?.message);
        }
    };

    const handleSendInvite = async () => {
        try {
            setLoading(true);
            // console.log("initialStateForm::: ", initialStateForm, user.token);
            await sendInvite(user.token, initialStateForm)
            toggleSuccessModal();
            // props.navigation.goBack();
        } catch (e) {
            console.log("Failed at fetchInvitedUsers:: ", e?.response?.data);
            setError(e);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchInvitedUsers()
    }, [])

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible);
    };

    const toggleSuccessModal = () => {
        setSuccessVisible(!successVisible);
        setTimeout(() => {
            props.history.goBack();
        }, 2500);
    };

    const toggleDelete = () => {
        setDelIsVisible(!delIsVisible);
    };

    const toggleDelSuccessModal = () => {
        setDelIsVisible(false);
        setDelSuccessVisible(!delSuccessVisible);
        setTimeout(() => {
            props.history.push("/dashboard");
            setDelSuccessVisible(false);
        }, 2500);
    };

    const handleFormChange = (name, value) => {
        setInitialStateForm((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Phone formatting
    useEffect(() => {
        const phone = initialStateForm.guestContactNo || "";
        let phoneLength = phone.length;
        let formattedNumber = "";

        if (phoneLength < 4) {
            formattedNumber = initialStateForm.guestContactNo;
        } else {
            if (phoneLength > 3 && phoneLength < 7) {
                formattedNumber = `(${initialStateForm.guestContactNo
                    .toString()
                    .slice(0, 3)}) ${initialStateForm.guestContactNo.toString().slice(3)}`;
            } else {
                formattedNumber = `(${initialStateForm.guestContactNo
                    .toString()
                    .slice(0, 3)}) ${initialStateForm.guestContactNo
                        .toString()
                        .slice(3, 6)}-${initialStateForm.guestContactNo
                            .toString()
                            .slice(6, 10)}`;
            }
        }

        setDisplayPhone(formattedNumber);
    }, [initialStateForm.guestContactNo]);

    const toggleRow = (id) => {
        if (expandedRows.includes(id)) {
            setExpandedRows(expandedRows.filter(rowId => rowId !== id));
        } else {
            setExpandedRows([...expandedRows, id]);
        }
    };

    const handleRoleSelection = (role) => {
        if (selectedRoles.includes(role)) {
            setSelectedRoles(selectedRoles.filter(r => r !== role));
        } else {
            setSelectedRoles([...selectedRoles, role]);
        }
    };

    // Update the form when selectedRoles changes
    useEffect(() => {
        handleFormChange("role", selectedRoles.join(", "));
    }, [selectedRoles]);

    // Set initial roles when user data is loaded
    useEffect(() => {
        if (initialStateForm.role) {
            const rolesArray = initialStateForm.role.split(",").map(role => role.trim());
            setSelectedRoles(rolesArray);
        }
    }, [initialStateForm.role]);

    return (

            <div className="settings-container" style={{ background: 'white' }}>
            <UserSidebar />
                <ErrorOverlay
                    onBackdropPress={() => setError(null)}
                    visible={!!error}
                    error={error}
                />
                <div className="settings-header">
                    <h1 className="header-txt-settings" style={{ color: "#1a2a6c" }}>ACCOUNT SHARING</h1>
                </div>

                <div className="options-container">
                    <div className="options-view">
                        <div className="acc-row">
                            <h2 className="options-text">Shared Users</h2>
                        </div>
                    </div>
                </div>
                <div className="SharedUsers" style={{ display: 'flex', justifyContent: 'right', marginRight: '100px' }}>
                    <div className="sharedUserTable">
                        <div className="table-header acc-row">
                            <h3 className="cell header-cell col2">Email</h3>
                            <h3 className="cell header-cell col1">Role</h3>
                            <h3 className="cell header-cell col1">Status</h3>
                        </div>

                        <div className="table-scroll-container">
                            {invitations?.map(invitation => (
                                <div key={invitation.id} className="invitation-row">
                                    <div className="acc-row table-row">
                                        <div className="cell col2">{invitation.guestEmail}</div>
                                        <div className="cell col1">{invitation?.role}</div>
                                        <div className="cell col1">{invitation.status}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="options-view invite-section">
                    <div className="acc-row" onClick={toggleFormVisibility}>
                        <h2 className="options-text">Invite Users</h2>
                        <span className="chevron-icon-accShare">
                            {isFormVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </span>
                    </div>

                </div>

                {isFormVisible && (
                    <div style={{display: 'flex', justifyContent: 'right'}}>
                    <div className="containerCreateTeam-accSettings">
                        <ErrorOverlay
                            visible={!!error}
                            error={error}
                            onBackdropPress={() => setError(null)}
                        />
                        <form className="createTeamForm-accSettings" onSubmit={(e) => e.preventDefault()}>
                            <div className="nameInputRowCreateTeam">
                                <label className="nameTxtCreateTeam">Guest Name:</label>
                                <input
                                    className="inputCreateTeam"
                                    type="text"
                                    placeholder="Enter guest name"
                                    value={initialStateForm.guestName}
                                    onChange={(e) => handleFormChange("guestName", e.target.value)}
                                />
                            </div>
                            <div className="nameInputRowCreateTeam">
                                <label className="nameTxtCreateTeam">Guest Email:</label>
                                <input
                                    className="inputCreateTeam"
                                    type="text"
                                    placeholder="Enter guest email"
                                    value={initialStateForm.guestEmail}
                                    onChange={(e) => handleFormChange("guestEmail", e.target.value)}
                                />
                            </div>

                            <div className="nameInputRowCreateTeam" onClick={() => setSelectTeamsVisible(true)}>
                                <label className="nameTxtCreateTeam">Teams:</label>
                                <div className="teams-selector" onClick={() => setSelectTeamsVisible(true)}>
                                    {selectedTeams.length > 0
                                        ? selectedTeams.map(t => t.teamName).join(", ")
                                        : "Select teams"}
                                </div>
                            </div>

                            <div className="nameInputRowCreateTeam">
                                <label className="nameTxtCreateTeam" style={{ marginRight: "10px" }}>Role: </label>
                                {['Head Coach', 'Coach', 'Volunteer'].map((role) => (
                                    <div
                                        key={role}
                                        className="checkbox-row"
                                        onClick={() => handleRoleSelection(role)}
                                    >
                                        <div className={`checkbox ${selectedRoles.includes(role) ? 'checkbox-selected' : ''}`}>
                                            {selectedRoles.includes(role) && "✓"}
                                        </div>
                                        <span className="checkbox-label">{role}</span>
                                    </div>
                                ))}
                            </div>
                            <button
                                className="saveBtnCreateTeam"
                                onClick={handleSendInvite}
                                disabled={loading}
                            >
                                {loading ? "Inviting..." : "Invite"}
                            </button>
                        </form>
                    </div>
                    </div>
                )}

                {successVisible && (
                    <SuccessOverlay
                        onBackdropPress={() => toggleSuccessModal(false)}
                        isVisible={successVisible}
                        type="User has been updated successfully!"
                        noTick={true}
                    />
                )}

                {selectTeamsVisible && (
                    <TeamsListModal
                        isVisible={selectTeamsVisible}
                        setSelectedTeams={(teams) => setSelectedTeams(teams)} // keep objects for UI
                        handleFormChange={handleFormChange} // pass it down so modal can send ids
                        onBackdropPress={() => setSelectTeamsVisible(false)}
                    />
                )}
            </div>

    );
};

export default AccountSharing;